import { Injectable, TemplateRef } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../common/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  /**
   * Opens a simple snackbar with a message
   * @param message Message to display
   * @param action Action text
   * @param config Additional configuration
   */
  openSimple(
    message: string,
    action: string = 'Close',
    config: MatSnackBarConfig = {}
  ): MatSnackBarRef<any> {
    const defaultConfig: MatSnackBarConfig = {
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      ...config
    };

    return this.snackBar.open(message, action, defaultConfig);
  }

  /**
   * Opens a custom snackbar with data
   * @param data Data to pass to the custom snackbar
   * @param config Additional configuration
   */
  openCustom(
    data: {
      message: string;
      title?: string;
      template?: TemplateRef<any>;
      type?: 'success' | 'error' | 'info' | 'warning';
      action?: string;
    },
    config: MatSnackBarConfig = {}
  ): MatSnackBarRef<SnackbarComponent> {
    const defaultConfig: MatSnackBarConfig = {
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: data.type ? [`snackbar-${data.type}`] : [],
      data,
      ...config
    };

    return this.snackBar.openFromComponent(SnackbarComponent, defaultConfig);
  }

  dismissAll(): void {
    this.snackBar.dismiss();
  }
}